<template>
  <div class="user_container">
    <div class="goback">
      <div @click="goback">
        <i class="el-icon-arrow-left"></i>
        <span>返回</span>
      </div>
    </div>
    <div class="search">
      <div class="pick">
        <div class="newDate" @click="showPickDate = true">
          {{ newDate }}
        </div>
        <i class="el-icon-date"></i>
        <van-popup v-model="showPickDate" position="bottom">
          <van-datetime-picker
            v-model="currentDate"
            type="year-month"
            title="选择年月"
            :min-date="minDate"
            :max-date="maxDate"
            :formatter="formatter"
            @confirm="comfirmPickTime"
            @cancel="showPickDate = false"
          />
        </van-popup>
      </div>
      <div class="pick">
        <div class="newDate" @click="showPickText = true">
          {{ newText }}
        </div>
        <i class="el-icon-arrow-down"></i>
        <van-popup v-model="showPickText" position="bottom">
          <van-picker
            show-toolbar
            :columns="optionsType"
            @confirm="onConfirmText"
            @cancel="showPickText = false"
          />
        </van-popup>
      </div>
    </div>
    <div class="radio_con">
      <div class="newDate" @click="showStatus = true">
        {{ newStatus }}
      </div>
      <i class="el-icon-arrow-down"></i>
      <van-popup v-model="showStatus" position="bottom">
        <van-picker
          show-toolbar
          :columns="optionsStatus"
          @confirm="onConfirmStatus"
          @cancel="showStatus = false"
        />
      </van-popup>
    </div>
    <div class="content" v-if="historyList.length > 0">
      <!-- <van-list
        v-if="historyList.length > 0"
        v-model="loadingOne"
        :finished="finishedOne"
        finished-text="没有更多了"
        @load="onLoadOne"
        loading-text="加载中，下拉查看更多"
        offset="10"
        :immediate-check="false"
      > -->
      <div
        class="list_con"
        @click="toUrl(item)"
        v-for="(item, index) in historyList"
        :key="index"
      >
        <!-- 审批通过 status2 待审批status1 审批驳回status3-->
        <div class="status_con">
          <div class="status status1" v-if="item.state == 1">待审批</div>
          <div class="status status2" v-if="item.state == 2">审批通过</div>
          <div class="status status3" v-if="item.state == 3">审批驳回</div>
        </div>
        <div class="item_con">
          <div class="item_left">提报类型</div>
          <div class="item_right">{{ optionsType[item.pbType].text }}</div>
        </div>
        <div class="item_con">
          <div class="item_left">提报审批时间</div>
          <div class="item_right" v-if="item.createTime">{{ item.createTime }}</div>
          <div class="item_right" v-else>暂无</div>
        </div>
      </div>
      <!-- </van-list> -->
    </div>
    <div class="kong_con" v-else>
      <img class="kong_img" src="@/assets/newsNotice/kong.png" alt="" />
      <div class="kong_title kong_title1">暂无历史记录</div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import api from "@/apis/medal";
import apis from "@/apis/publicWelfare";
import { getToken } from "@/utils/cookie";
export default {
  name: "history",
  props: {},
  components: {},
  data() {
    return {
      showPickDate: false,
      showPickText: false,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      newDate: moment(new Date()).format("YYYY-MM"),
      newText: "全部",
      newValue: 0,
      newStatus: "审批状态",
      newStatusValue: 0,
      historyList: [],
      imgUrl: "",
      loadingOne: false,
      finishedOne: false,
      total: 0,
      page: 1,
      pageSize: 20,
      optionsType: [
        {
          value: 0,
          text: "全部",
        },
        {
          value: 1,
          text: "无偿献血",
        },
        {
          value: 2,
          text: "志愿服务",
        },
        {
          value: 3,
          text: "指尖公益",
        },
        {
          value: 4,
          text: "公益捐款",
        },
        {
          value: 5,
          text: "公益捐赠",
        },
        {
          value: 6,
          text: "团队时长",
        },
      ],
      showStatus: false,
      optionsStatus: [
        {
          value: 0,
          text: "全部",
        },
        {
          value: 1,
          text: "待审批",
        },
        {
          value: 2,
          text: "审批通过",
        },
        {
          value: 3,
          text: "审批驳回",
        },
      ],
    };
  },
  created() {},
  mounted() {
    this.imgUrl = api.imgUrl;
    this.onLoadOne();
  },
  methods: {
    // 格式化日期
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      } else if (type === "day") {
        return ``;
      }
      return val;
    },
    // 返回
    goback() {
      this.$router.go(-1);
    },
    // 搜索
    search() {
      this.queryHistoryRecord();
    },
    // 确认选择时间
    comfirmPickTime(value) {
      this.newDate = moment(value).format("YYYY-MM");
      this.currentDate = value;
      this.queryHistoryRecord();
      this.showPickDate = false;
    },
    // 选择时间
    onConfirmText(value) {
      this.newText = value.text;
      this.newValue = value.value;
      this.showPickText = false;
      this.onLoadOne();
    },
    // 选择状态
    onConfirmStatus(value) {
      this.newStatus = value.text;
      this.newStatusValue = value.value;
      this.showStatus = false;
      this.onLoadOne();
    },
    onLoadOne() {
      this.queryHistoryRecord();
    },
    // 跳转公益审批
    toUrl(item){
      this.$router.push({
        path: "/mobile/medal/publicWelfare/submitWelfareApprove",
        query:{
          id: item.id,
          type: 2
        }
      });
    },
    // 查询历史记录
    queryHistoryRecord() {
      apis
        .history({
          // page: this.page,
          // pageSize: this.pageSize
          empNo: getToken(),
          type: 2,
          pbType: this.newValue,
          state: this.newStatusValue,
          time: this.newDate,
        })
        .then((res) => {
          if (res.code == 200) {
            this.historyList = res.data;
            this.historyList.forEach((item) => {
              if (item.createTime) {
                item.createTime = moment(item.createTime).format(
                  "YYYY-MM-DD HH:mm"
                );
              }
            });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .user_container {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .user_container {
    width: 276px * $zoom;
  }
}
.user_container {
  //   width: 100%;
  min-height: 100vh;
  padding: 30px;
  // background: #fff;
  background: url("~@/assets/newMedal/bg2.png");
  background-size: 100% 100%;
  .detail_title_info {
    width: 100%;
    height: 100%;
  }
}
.goback {
  margin: 10px 0 40px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  div {
    display: flex;
    align-items: center;
  }

  i {
    font-weight: bold;
    font-size: 48px;
    margin-right: 40px;
  }

  span {
    font-size: 34px;
    flex-shrink: 0;
  }
}
.search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: auto;
  .pick {
    width: 48%;
    height: 80px;
    border-radius: 80px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px;
    margin-bottom: 15px;
    .newDate {
      flex: 1;
      // height: 40px;
    }
    div {
      color: #969b9e;
      font-size: 30px;
    }
    i {
      color: #969b9e;
    }
  }
}
.radio_con {
  width: 100%;
  height: 80px;
  border-radius: 80px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  margin-bottom: 15px;
  .newDate {
    flex: 1;
    // height: 40px;
  }
  div {
    color: #969b9e;
    font-size: 30px;
  }
  i {
    color: #969b9e;
  }
}
.content {
  overflow: auto;
  height: calc(100vh - 385px);
  margin-top: 30px;
  &::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
  .list_con {
    margin-bottom: 40px;
    font-size: 30px;
    background: #fff;
    padding: 40px 30px 20px 30px;
    border-radius: 40px;
    .status_con {
      width: 100%;
      position: relative;
      margin-bottom: 20px;
      .status {
        position: absolute;
        right: -30px;
        top: -40px;
        padding: 12px 35px;
        font-size: 22px;
        border-radius: 8px 40px 5px 15px;
      }
      .status1 {
        background: #fee9d2;
        color: #f88100;
      }
      .status2 {
        background: #e7f7ef;
        color: #0caf60;
      }
      .status3 {
        background: #ffe9e9;
        color: #fa6666;
      }
    }

    .item_con {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 40px 0;
      font-size: 26px;
      .item_left {
        font-weight: 400;
        color: #969b9e;
      }
      .item_right {
        color: #282b32;
        font-weight: 500;
      }
    }
  }
}
.kong_con {
  width: 100%;
  height: 60%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 50px;
  justify-content: center;
  .kong_img {
    width: 450px;
    height: 450px;
  }
  .kong_title1 {
    margin-top: 30px !important;
  }
  .kong_title {
    color: #999999;
    font-size: 26px;
    margin-top: 10px;
  }
}
</style>
